export default {"src":"/_next/static/media/slide-flexible-icon.4ba68a6f.svg","height":80,"width":77};